/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-access-state-in-setstate */

import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import Checkbox from 'react-three-state-checkbox/lib/Checkbox';
import { Dispatch } from 'redux';
import { change } from 'redux-form';
import {
  EventType,
  EventVideoViewModel,
  isUnknownParticipantName,
  ParticipantState,
  ParticipantViewModel,
} from 'stageclip-common';

import { createAllEventVideosRequestedAction } from '../../../actions/eventVideosActions';
import { createAllEventParticipantsRequestedAction } from '../../../actions/participantActions';
import { DataRequestActionTypes } from '../../../constants/actionTypes';
import { FormId } from '../../../constants/formId';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { getAllWithIds, getItem } from '../../../store/selectors';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../../componentBase';
import { AppCheckboxField } from '../../form/appCheckboxField';
import { AppSelectField } from '../../form/appSelectField';
import { required } from '../../form/formValidations';
import FormModal from '../../modal/formModal';

import { ParticipantsState } from './participantsState';
import styles from './sendParticipantsToGeneratorForm.module.scss';

interface SendParticipantsToGeneratorFormOwnProps {
  eventId: string;
}

interface SendParticipantsToGeneratorFormStateProps extends BaseStateProps {
  eventVideos: EventVideoViewModel[];
  participants: ParticipantViewModel[];
  formValues: any;
  eventType: EventType;
}

interface SendParticipantsToGeneratorFormDispatchProps extends BaseDispatchProps {
  loadEventParticipants: (c: SendParticipantsToGeneratorForm) => void;
  loadEventsVideos: (c: SendParticipantsToGeneratorForm) => void;
  changeFieldValue: (field: string, value: any) => void;
}

interface SendParticipantsToGeneratorFormState {
  filteredParticipants: ParticipantViewModel[];
  sendParticipantToGenerator: boolean;
  filteredParticipantId?: string;
}

enum CheckboxState {
  AllChecked,
  AllUnchecked,
  PartiallyChecked,
}

class SendParticipantsToGeneratorForm extends ComponentBase<
  SendParticipantsToGeneratorFormOwnProps,
  SendParticipantsToGeneratorFormStateProps,
  SendParticipantsToGeneratorFormDispatchProps,
  SendParticipantsToGeneratorFormState
> {
  private checkBoxesState: any;

  private participants: any;

  constructor(props: any) {
    super(props);
    this.checkBoxesState = {
      error: CheckboxState.AllUnchecked,
      processed: CheckboxState.AllUnchecked,
      readyToGenerateClip: CheckboxState.AllChecked,
      sentToGenerator: CheckboxState.AllUnchecked,
    };
    this.state = {
      filteredParticipants: undefined,
      sendParticipantToGenerator: true,
      filteredParticipantId: undefined,
    };
  }

  protected dataLoaded(props: any) {
    return props.participants;
  }

  protected async loadData(props: any) {
    if (!props.eventVideos) {
      await props.loadEventsVideos(this);
    }
  }

  protected loggedInRender() {
    this.participants = {
      error: this.getParticipantsWithState(ParticipantState.Error),
      processed: this.getParticipantsWithState(ParticipantState.Processed),
      readyToGenerateClip: this.getParticipantsWithState(ParticipantState.ReadyToGenerateClip),
      sentToGenerator: this.getParticipantsWithState(ParticipantState.SentToGenerator),
    };

    const initialValues = {
      uploadToClipSite: this.props.eventType === EventType.Graduation,
    };

    this.participants.readyToGenerateClip.forEach((p: any) => {
      initialValues[p.id.toString()] = true;
    });

    const preprocessDataOnSubmit = this.preprocessDataOnSubmit.bind(this);

    const preprocessDataOnSubmitForLiveAndHybridEvent = this.preprocessDataOnSubmitForLiveAndHybridEvent.bind(this);

    const onModalClosed = this.onModalClosed.bind(this);

    return (
      <>
        {this.props.eventType === EventType.LiveEvent ||
        this.props.eventType === EventType.HybridClipsOnlyEvent ||
        this.props.eventType === EventType.HybridFullCeremonyEvent ? (
          <FormModal
            formId={FormId.SendLiveParticipantsToGenerator}
            formTitle="Send participants to clip generator"
            buttonIcon={faPaperPlane}
            invertedButtonColours
            initialValues={initialValues}
            submitActionType={DataRequestActionTypes.SendLiveParticipantsToGeneratorRequested}
            reduxData={{ eventId: this.props.eventId, eventType: this.props.eventType }}
            preprocessDataOnSubmit={preprocessDataOnSubmitForLiveAndHybridEvent}
            onClosed={onModalClosed}
            onSuccessCallback={() => this.props.loadEventParticipants(this)}
          >
            <AppCheckboxField
              name="showParticipants"
              label="Send to all Participants"
              value={this.state.sendParticipantToGenerator}
              onChange={() => this.setState({ sendParticipantToGenerator: !this.state.sendParticipantToGenerator })}
            />
            {!this.state.sendParticipantToGenerator && (
              <AppSelectField
                name="participantId"
                options={this.getParticipants()}
                label="Select Participants"
                onChangeCallback={this.selectParticipant}
                validate={[required]}
              />
            )}
          </FormModal>
        ) : (
          <FormModal
            formId={FormId.SendParticipantsToGenerator}
            formTitle="Send participants to generator"
            buttonIcon={faPaperPlane}
            invertedButtonColours
            initialValues={initialValues}
            submitActionType={DataRequestActionTypes.SendParticipantsToGeneratorRequested}
            reduxData={{ eventId: this.props.eventId }}
            preprocessDataOnSubmit={preprocessDataOnSubmit}
            onClosed={onModalClosed}
          >
            <AppSelectField
              name="eventVideoId"
              options={this.getEventVideosOptions()}
              label="Event Video"
              onChangeCallback={this.eventVideoUpdated}
              validate={[required]}
            />
            <AppCheckboxField name="uploadToClipSite" label="Upload to clip site" />
            {this.state.filteredParticipants && (
              <>
                <div>Select/Deselect all participants with status:</div>
                <div className={styles.checkboxes}>
                  {this.renderMainCheckbox('Ready to Generate Clip', 'readyToGenerateClip')}
                  {this.renderMainCheckbox('Processed', 'processed')}
                  {this.renderMainCheckbox('Error', 'error')}
                  {this.renderMainCheckbox('Sent to generator', 'sentToGenerator')}
                </div>
                {this.displayParticipants('readyToGenerateClip')}
                {this.displayParticipants('error')}
                {this.displayParticipants('processed')}
                {this.displayParticipants('sentToGenerator')}
              </>
            )}
          </FormModal>
        )}
      </>
    );
  }

  private getEventVideosOptions() {
    return this.props.eventVideos ? this.props.eventVideos.map(ev => ({ value: ev.id, label: ev.name })) : [];
  }

  private getParticipants() {
    return this.props.participants ? this.props.participants.map(ev => ({ value: ev.id, label: ev.fullName })) : [];
  }

  private renderMainCheckbox(label: string, group: string) {
    const onChange = this.onGroupCheckboxChange(group).bind(this);

    return (
      <div className={styles.mainCheckbox}>
        {label}&nbsp;
        <Checkbox
          checked={this.checkBoxesState[group] === CheckboxState.AllChecked}
          indeterminate={this.checkBoxesState[group] === CheckboxState.PartiallyChecked}
          onChange={onChange}
        />
      </div>
    );
  }

  private onModalClosed = () => {
    this.setState({
      filteredParticipants: undefined,
    });
    this.checkBoxesState = {
      error: CheckboxState.AllUnchecked,
      processed: CheckboxState.AllUnchecked,
      readyToGenerateClip: CheckboxState.AllChecked,
      sentToGenerator: CheckboxState.AllUnchecked,
    };
  };

  private preprocessDataOnSubmit = (formData: any) => {
    return {
      eventVideoId: formData.eventVideoId,
      participantIds: Object.keys(formData).reduce((f, key) => {
        if (key !== 'eventVideoId' && key !== 'uploadToClipSite' && formData[key]) {
          f.push(key);
        }

        return f;
      }, []),
      uploadToClipSite: formData.uploadToClipSite,
    };
  };

  private preprocessDataOnSubmitForLiveAndHybridEvent = () => {
    return {
      eventId: this.props.eventId,
      participantId: this.state.sendParticipantToGenerator ? undefined : this.state.filteredParticipantId,
    };
  };

  private onGroupCheckboxChange = (group: string) => async () => {
    this.checkBoxesState[group] =
      this.checkBoxesState[group] === CheckboxState.AllChecked ? CheckboxState.AllUnchecked : CheckboxState.AllChecked;

    if (this.checkBoxesState[group] === CheckboxState.AllChecked) {
      await this.participants[group].forEach(async (p: any) => {
        await this.props.changeFieldValue(p.id, true);
      });
    } else {
      await this.participants[group].forEach(async (p: any) => {
        await this.props.changeFieldValue(p.id, false);
      });
    }
  };

  private onParticipantCheckboxChange = (group: string) => async (input: any) => {
    if (input.target.checked) {
      if (this.checkBoxesState[group] === CheckboxState.PartiallyChecked) {
        if (
          !this.participants[group].some(
            (p: any) => p.id !== input.target.name && this.props.formValues && !this.props.formValues[p.id],
          )
        ) {
          this.checkBoxesState[group] = CheckboxState.AllChecked;
        }
      } else {
        this.checkBoxesState[group] = CheckboxState.PartiallyChecked;
      }
    } else if (this.checkBoxesState[group] === CheckboxState.PartiallyChecked) {
      if (
        !this.participants[group].some(
          (p: any) => p.id !== input.target.name && this.props.formValues && this.props.formValues[p.id],
        )
      ) {
        this.checkBoxesState[group] = CheckboxState.AllUnchecked;
      }
    } else {
      this.checkBoxesState[group] = CheckboxState.PartiallyChecked;
    }
  };

  private displayParticipants(group: string) {
    const onChange = this.onParticipantCheckboxChange(group).bind(this);

    return this.participants[group].map((p: any) => (
      <AppCheckboxField
        name={p.id}
        label={this.participantLabel(p)}
        key={p.id}
        inputClassName={styles.input}
        labelClassName={styles.label}
        onChange={onChange}
      />
    ));
  }

  private participantLabel(participant: ParticipantViewModel) {
    return (
      <div className={styles.participantLabel}>
        <div className={styles.participantName}>{participant.fullName}</div>
        <ParticipantsState state={participant.state} />
      </div>
    );
  }

  private eventVideoUpdated = (value: any) => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      ...this.state,
      filteredParticipants: value.value
        ? this.props.participants.filter(p => p.eventVideo && p.eventVideo.id === value.value)
        : undefined,
    });
  };

  private selectParticipant = (value: any) => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      ...this.state,
      filteredParticipants: value.value ? this.props.participants.filter(p => p.fullName) : [],
      filteredParticipantId: value.value,
    });
  };

  private getParticipantsWithState(state: ParticipantState) {
    return this.state.filteredParticipants ? this.state.filteredParticipants.filter(p => p.state === state) : [];
  }
}

function mapStateToProps(
  state: ClippingPlatformState,
  ownProps: SendParticipantsToGeneratorFormOwnProps,
): SendParticipantsToGeneratorFormStateProps {
  const event = getItem(state.entities.events, ownProps.eventId);
  const formData = state.form[FormId.SendParticipantsToGenerator];
  const allParticipants = getAllWithIds(state.entities.participants, event.participants);

  return {
    ...baseMapStateToProps(state),
    eventType: event.type,
    eventVideos: getAllWithIds(state.entities.eventVideos, event.eventVideos),
    formValues: formData ? formData.values : undefined,
    participants: allParticipants ? allParticipants.filter(p => !isUnknownParticipantName(p.fullName)) : null,
  };
}

function mapDispatchToProps(
  dispatch: Dispatch,
  ownProps: SendParticipantsToGeneratorFormOwnProps,
): SendParticipantsToGeneratorFormDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    changeFieldValue: (field, value) => dispatch(change(FormId.SendParticipantsToGenerator, field, value)),
    loadEventParticipants: (c: SendParticipantsToGeneratorForm) =>
      dispatch(createAllEventParticipantsRequestedAction(ownProps.eventId, c, dispatch)),
    loadEventsVideos: (c: SendParticipantsToGeneratorForm) =>
      dispatch(createAllEventVideosRequestedAction(ownProps.eventId, c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SendParticipantsToGeneratorForm);
